import React, { useState, useEffect } from 'react';
import AdminDashboard from './AdminDashboard';
import Swal from 'sweetalert2';
import '../../assets/css/admin/allcourses.css';

const AllApplications = () => {
    const [applications, setApplications] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        fetchApplications();
    }, []);

    const fetchApplications = async () => {
        try {
            const response = await fetch('https://api.myskills.lk/applications/all');
            const data = await response.json();
            setApplications(data);
        } catch (error) {
            console.error('Error fetching applications:', error);
        }
    };

    const handleDelete = async (applicationId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to delete this application?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await fetch(`https://api.myskills.lk/applications/delete/${applicationId}`, {
                        method: 'POST'
                    });
                    if (response.ok) {
                        // Update local state after successful deletion
                        const updatedApplications = applications.filter(application => application.id !== applicationId);
                        setApplications(updatedApplications);
                        
                        // Show success message
                        Swal.fire({
                            title: "Deleted!",
                            text: "The application has been deleted.",
                            icon: "success"
                        });
                    } else {
                        console.error('Failed to delete application');
                        Swal.fire({
                            title: "Error!",
                            text: "Failed to delete the application.",
                            icon: "error"
                        });
                    }
                } catch (error) {
                    console.error('Error deleting application:', error);
                    Swal.fire({
                        title: "Error!",
                        text: "Failed to delete the application.",
                        icon: "error"
                    });
                }
            }
        });
    };

    // Filter applications based on search term
    const filteredApplications = applications.filter(app => 
        (app.appName && app.appName.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (app.ownerName && app.ownerName.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (app.ownerEmail && app.ownerEmail.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (app.contact && app.contact.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    const handleSearchSubmit = (e) => {
        e.preventDefault(); // Prevent form submission
    };

        // const handleEdit = (tuitionId) => {
    //     // Navigate to edit page or show edit form in place
    //     // For example, navigate to `/edit-tuition/${tuitionId}` or show form inline
    //     console.log('Edit course with ID:', tuitionId);
    // };


    return (
        <div>
            <AdminDashboard />

            <div className='AllViews-admin-course'>
                <div className="search-icon-admin admin-course-search">
                    <h1>ALL APPLICATIONS</h1>
                    <form onSubmit={handleSearchSubmit}>
                        <input 
                            type="text" 
                            placeholder='Search Item' 
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <input type="submit" value="SEARCH" />
                    </form>
                </div>

                <div className="scroller-box">
                    <div className="table-course">
                    <table>
                            <thead>
                                <tr>
                                    <th>Application Name</th>
                                    <th>Owner Name</th>
                                    <th>Owner Email</th>
                                    <th>Owner Contact</th>
                                    <th>Link</th>
                                    <th>PDF Application</th>
                                    <th>Expire Time</th>
                                    <th>View</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                            {filteredApplications.map((application) => (
                                    <tr key={application.id}>
                                        <td>{application.appName}</td>
                                        <td>{application.ownerName}</td>
                                        <td>{application.ownerEmail}</td>
                                        <td>{application.contact}</td>
                                        <td>
                                            <a href={application.link} target="_blank" rel="noopener noreferrer">
                                                View Link
                                            </a>
                                        </td>
                                        <td>
                                            <a href={`https://api.myskills.lk/Upload/pdf/${application.application}`} target="_blank" rel="noopener noreferrer">
                                                View PDF
                                            </a>
                                        </td>
                                        <td>
                                            {new Date(application.expire_time).toLocaleString('en-US', {
                                                year: 'numeric',
                                                month: '2-digit',
                                                day: '2-digit',
                                                hour: '2-digit',
                                                minute: '2-digit',
                                                hour12: true
                                            }).replace(',', ' -')}
                                        </td>
                                        <td>
                                            {application.website ? (
                                                <a href={application.website} target="_blank" rel="noopener noreferrer" id='view-website'>WEBSITE</a>
                                            ) : (
                                                <span style={{ color: '#999' }}>No Website</span>
                                            )}
                                        </td>
                                        <td id='action-buttons'>
                                            {/* <a href="#!" id='man-details' onClick={() => handleEdit(application.id)}>EDIT</a> */}
                                            <a href="#!" id='del-details' onClick={() => handleDelete(application.id)}>DELETE</a>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table> 
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AllApplications;
